import configService from "./ConfigService";
import firebase from "firebase/app";
import 'firebase/messaging'

export default class NotificationService {
    static async init(registration) {        
        var config = await configService.getConfig();
        if (!firebase.apps.length) {
            //console.log('Initing Firebase 1...', firebaseConfig);
            firebase.initializeApp(config.firebaseConfig);            
        }
        else {
            firebase.app().delete().then(function() {
                //console.log('Initing Firebase 1...', firebaseConfig);
                firebase.initializeApp(config.firebaseConfig);
              });
        }
        //console.log('Firebase initialized!');

        try {
            const messaging = firebase.messaging();
            messaging.useServiceWorker(registration);
            //console.log('Firebase set to use service worker!', registration);
            await messaging.requestPermission();
            var token = await messaging.getToken();
            console.log("FCM Token:", token);
            // TODO: register token with server for messaging...  (need to tie to offer token)
            var res = await NotificationService.postData('api/subscribe/' + token);
            //console.log('setting up onMessage handler');
            messaging.onMessage(payload => {
              //console.log('Notification payload!', payload);
                const title = payload.notification.title;            
                const options = {
                    body: payload.notification.body,
                    icon: payload.notification.icon,
                    data: {url: payload.data.url}
                };                
                return registration.showNotification(title, options);
              });               
        }
        catch(error)         
        {
            if (error.code === "messaging/permission-blocked") {
                console.log("Please Unblock Notification Request Manually");
            } else {
                console.log("Error Occurred", error);
            }
        }
    }

    static async postData(url = '', data = {}) {
        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
        });
    }

    static async sendMessage(){
        
    }
}